import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'
import type { Tables } from '@muaa/shared'

type Fund = Tables<'funds'>

export function FundEdit() {
  const { formProps, saveButtonProps } = useForm<Fund>()

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Fund name is required' }]}
        >
          <Input placeholder="e.g. General Fund, Scholarship Fund" />
        </Form.Item>
        <Form.Item
          label="Cheddar Up URL"
          name="cheddarup_url"
          help="Optional. A per-fund Cheddar Up collection link. Overrides the collection-wide default set in Giving Settings when Cheddar Up is the active provider."
        >
          <Input placeholder="https://muaa.cheddarup.com/c/..." />
        </Form.Item>
      </Form>
    </Edit>
  )
}
